<template>
  <div class="my-card text-center">
    <router-link :to="{ name: 'PerfilPsicologoPaciente', params: { id: slug } }" class="text-center">
      <v-avatar size="120">
        <v-img :src="img"></v-img>
      </v-avatar>
      <v-row justify="center" no-gutters>
        <v-col>
          <p class="text--my-card text-center text-truncate">
            {{ name }}
            <v-icon v-if="isChiefTherapist" dark class="primary--text icon-psy-name" size="32">bookmark</v-icon>
          </p>
          <v-chip v-if="hasVacancies" small color="success" text-color="white" class="mt-1">
            Horário Disponível
          </v-chip>
          <v-chip v-else small color="gray" text-color="white" class="mt-1">
            Sem Horário
          </v-chip>
        </v-col>
      </v-row>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    name: String,
    id: Number,
    slug: String,
    isChiefTherapist: Boolean,
    hasVacancies: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.my-card {
  // width: 260px;
  min-height: 200px;
  padding: 10px;
  background-color: var(--v-gray-lighten5);
  border-radius: 8px;

  a {
    text-decoration: none;
  }
}

.text--my-card {
  margin: 10px 0;
  padding: 8px 50px;
  border-radius: 20px;
  background-color: var(--v-white-base);
  position: relative;

  .icon-psy-name {
    position: absolute;
    top: -5px;
    right: 11px;
  }
}
</style>
